module.exports = __webpack_public_path__ + "static/media/takeoff.b078ab7f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/takeoff.webp
// module id = 557
// module chunks = 4